import 'react-app-polyfill/ie11';
import 'core-js/fn/string/includes';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/string/ends-with';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/keys';
import 'core-js/fn/object/values';
import 'core-js/es6/set';
import 'core-js/fn/number/is-finite'; // recharts
import 'core-js/fn/number/is-nan';



// WEBPACK FOOTER //
// ./src/polyfills.ts